import { Grid } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SingleOverride } from "../Common/SingleOverride";
import {
  generateModalNewOverrides,
  updateModalNewOverrides,
} from "../../../../reducers/matrixProfile/thunkActions";
import { editModalOverridesSelector } from "../../../../reducers/matrixProfile/selectors";

const useStyles = makeStyles({
  container: {
    minHeight: "100px",
  },
  text: {
    marginBottom: "20px",
  },
});

export const NewOverrideContent = memo(({ onValidated }) => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const { newOverrides } = useSelector(editModalOverridesSelector);
  const newOverride = Object.values(newOverrides || {})[0];

  useEffect(() => {
    dispatch(generateModalNewOverrides());
  }, [dispatch]);

  return newOverride ? (
    <Grid container direction={"column"} className={styles.container}>
      <Grid className={styles.text} item>
        Please Set Your Overrides For Selected Postcodes:
      </Grid>
      <Grid item>
        <SingleOverride
          override={newOverride}
          onChange={(override) => dispatch(updateModalNewOverrides(override))}
          onValidated={onValidated}
        />
      </Grid>
    </Grid>
  ) : null;
});
